// extracted by mini-css-extract-plugin
export var footerStyle = "footer-module--footerStyle--2smTq";
export var colStyle = "footer-module--colStyle--3Z_Ed";
export var social = "footer-module--social--2IRn3";
export var spamMe = "footer-module--spamMe--3-Mlq";
export var emailId = "footer-module--emailId--30hHO";